import React, { useEffect, useState } from "react";
import {
  CDropdown,
  CDropdownItem,
  CDropdownMenu,
  CDropdownToggle,
} from "@coreui/react";
import CIcon from "@coreui/icons-react";
import { useHistory } from "react-router-dom";
import { RootState } from "../../store";
import { useSelector, useDispatch } from "react-redux";
import { getItem } from "../../api/generics";
import { SUCCESS } from "../../utils/constants/tags";
import { getRoutePath } from "../../routes";

import { logOut } from "../../redux/actions/user";
import {
  setTaxPayerLoaded,
  setTaxPayerLoading,
  setUserTaxPayers,
} from "../../redux/tax-payer/tax-payer-slice";

const HeaderDropdown = () => {
  const dispatch = useDispatch();
  const history = useHistory();

  /**
   * Whether this person has anything to see under Conexiones de IA.
   *
   * True when they can connect one, and also when they merely have one live —
   * so that somebody whose last company just had the channel turned off still
   * has a way in to cut a connection that is already running.
   */
  const [aiVisible, setAiVisible] = useState(false);

  useEffect(() => {
    let cancelled = false;

    const load = async () => {
      const response = await getItem<{ visible: boolean }>(
        "/oauth/connections/",
      );

      if (!cancelled && response.status === SUCCESS) {
        setAiVisible(response.data?.visible === true);
      }
    };

    load();

    return () => {
      cancelled = true;
    };
  }, []);

  const handleLogout = async (e: React.MouseEvent) => {
    dispatch(logOut());
    dispatch(setTaxPayerLoaded(false));
    dispatch(setTaxPayerLoading(false));
    dispatch(setUserTaxPayers([]));
  };
  const user = useSelector((state: RootState) => state.user.email);
  return (
    <CDropdown inNav className="c-header-nav-items mx-2">
      <CDropdownToggle>{user}</CDropdownToggle>
      <CDropdownMenu className="pt-0" placement="bottom-end">
        <CDropdownItem header tag="div" color="light" className="text-center">
          <strong>Account</strong>
        </CDropdownItem>
        {/* <CDropdownItem>
          <CIcon name="cil-bell" className="mfe-2" />
          Updates
          <CBadge color="info" className="mfs-auto">
            42
          </CBadge>
        </CDropdownItem>
        <CDropdownItem>
          <CIcon name="cil-envelope-open" className="mfe-2" />
          Messages
          <CBadge color="success" className="mfs-auto">
            42
          </CBadge>
        </CDropdownItem>
        <CDropdownItem>
          <CIcon name="cil-task" className="mfe-2" />
          Tasks
          <CBadge color="danger" className="mfs-auto">
            42
          </CBadge>
        </CDropdownItem>
        <CDropdownItem>
          <CIcon name="cil-comment-square" className="mfe-2" />
          Comments
          <CBadge color="warning" className="mfs-auto">
            42
          </CBadge>
        </CDropdownItem>
        <CDropdownItem header tag="div" color="light" className="text-center">
          <strong>Settings</strong>
        </CDropdownItem>
        <CDropdownItem>
          <CIcon name="cil-user" className="mfe-2" />
          Profile
        </CDropdownItem>
        <CDropdownItem>
          <CIcon name="cil-settings" className="mfe-2" />
          Settings
        </CDropdownItem>
        <CDropdownItem>
          <CIcon name="cil-credit-card" className="mfe-2" />
          Payments
          <CBadge color="secondary" className="mfs-auto">
            42
          </CBadge>
        </CDropdownItem>
        <CDropdownItem>
          <CIcon name="cil-file" className="mfe-2" />
          Projects
          <CBadge color="primary" className="mfs-auto">
            42
          </CBadge>
        </CDropdownItem>
        <CDropdownItem divider /> */}
        {aiVisible && (
          <CDropdownItem
            onClick={() => history.push(getRoutePath("aiConnections"))}
          >
            <CIcon name="cil-link" className="mfe-2" />
            Conexiones de IA
          </CDropdownItem>
        )}
        <CDropdownItem onClick={handleLogout}>
          <CIcon name="cil-lock-locked" className="mfe-2" />
          Cerrar Sesión
        </CDropdownItem>
      </CDropdownMenu>
    </CDropdown>
  );
};

export default HeaderDropdown;
